var _regeneratorRuntime = require("/codebuild/output/src4196434007/src/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/codebuild/output/src4196434007/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var uuid = require("uuid");
/**
 * Gets a cookie.
 * @param {string} name - Cookie name to get.
 * @returns {string} Success or failure message of getting cookie.
 */


function getCookie(name) {
  try {
    var value = "; ".concat(document.cookie);
    var parts = value.split("; ".concat(name, "="));

    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    } else {
      return "Cookie not found.";
    }
  } catch (err) {
    return err;
  }
}
/**
 * Sets a cookie with the key pair provided.
 * @param {string} name - Cookie name to be set.
 * @param {string} value - Cookie value to be set.
 * @returns {string} Success or failure message of cookie setting.
 */


function setCookie(name, value) {
  try {
    if (name === 'userId') {
      document.cookie = "".concat(name, "=").concat(value, ";max-age=31536000");
      return "Cookie ".concat(name, " set successfully.");
    } else {
      document.cookie = "".concat(name, "=").concat(value, ";max-age=1800");
      return "Cookie ".concat(name, " set successfully.");
    }
  } catch (err) {
    return err;
  }
}
/**
 * Get the current session ID for analytics use.
 * @returns {string} Returns session ID or error message.
 */


function getSessionId() {
  try {
    var sessionId = getCookie('sessionId');

    if (sessionId === "Cookie not found.") {
      sessionId = uuid.v4();
      setCookie('sessionId', sessionId);
    }

    return sessionId;
  } catch (err) {
    return err;
  }
}
/**
 * Get the current user ID for analytics use.
 * @returns {string} Returns session ID or error message.
 */


function getUserId() {
  try {
    var userId = getCookie("userId");

    if (userId === "Cookie not found.") {
      userId = uuid.v4().replace(/-/g, "");
      setCookie("userId", userId);
    }

    return userId;
  } catch (err) {
    return err;
  }
}
/**
 * Build on page metadata for later access.
 * @param {object} data - Object of data to build metadata for.
 * @returns {string} Success or failure message of data processing.
 */


function buildOnPageMetadata(data) {
  return new Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
      var key, element;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              try {
                if (typeof document !== "undefined") {
                  for (key in data) {
                    element = document.createElement('data');
                    element.setAttribute('id', key);
                    element.setAttribute('value', data[key]);
                    document.body.appendChild(element);
                  }

                  resolve('On page metadata built successfully.');
                } else {
                  reject('Document not found.');
                }
              } catch (err) {
                reject(err);
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
}
/**
 * Get all on page metadata for event use.
 * @param {object} data - Object of data to build metadata for.
 * @returns {string} Success or failure message of data processing.
 */


function getAllOnPageMetadata() {
  return new Promise( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve, reject) {
      var dataTags, metadata;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              try {
                dataTags = document.querySelectorAll('data');
                metadata = {};
                dataTags.forEach(function (tag) {
                  return metadata[tag.id] = tag.value;
                });

                if (metadata.length > 0) {
                  resolve(metadata);
                } else {
                  reject('No metadata found.');
                }
              } catch (err) {
                reject(err);
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }());
}
/**
 * Get page type from url.
 * @returns {string} Page type or failure message of data processing.
 */


function getPageTypeFromURL() {
  try {
    var url = new URL(window.location.href);
    var pathname = url.pathname;
    if (pathname === '/') return 'Home';
    var page = pathname.split('/')[1].replace(/-/g, ' ');
    var formattedPage = page.split(' ').map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
    return formattedPage;
  } catch (err) {
    return err;
  }
}
/**
 * Get department for click to call event
 * @returns {string} Department or failure message of data processing.
 */


function getClickToCallDepartment(anchor, number) {
  try {
    // Get department from data attribute
    if (anchor.dataset.department) {
      return anchor.dataset.department;
    } // Get hash list from local storage


    var hashListKey;

    for (var i = 0; i < localStorage.length; i++) {
      var currentKey = localStorage.key(i);

      if (currentKey.startsWith("hashList")) {
        hashListKey = currentKey;
      }
    } // Get department from hash list


    if (hashListKey) {
      var data = JSON.parse(localStorage.getItem(hashListKey));

      var _iterator = _createForOfIteratorHelper(data),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (item.mainPhoneNumber && item.mainPhoneNumber.replace(/-/g, '').replace(/\s/g, '') === number) {
            return 'sales';
          }

          if (item.serviceDepartment && item.serviceDepartment.replace(/-/g, '').replace(/\s/g, '') === number) {
            return 'service';
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } // Default to sales


    return 'sales';
  } catch (err) {
    console.log(err);
    return 'sales';
  }
}

module.exports = {
  getCookie: getCookie,
  setCookie: setCookie,
  getSessionId: getSessionId,
  getUserId: getUserId,
  buildOnPageMetadata: buildOnPageMetadata,
  getAllOnPageMetadata: getAllOnPageMetadata,
  getPageTypeFromURL: getPageTypeFromURL,
  getClickToCallDepartment: getClickToCallDepartment
};